import appAxios from "./axios"
class CountriesService {
    getAll() {
        return appAxios.get('/countries')
    }
}
export const countriesService = new CountriesService()